import { Control } from 'react-hook-form';

import { SelectInputProps } from '@/components/form/baseInputs/SelectInput/SelectInput';
import { FormAwareTextInput } from '@/components/form/formAwareInputs/FormAwareTextInput';
import { TrustAdvisorLevel, TrustAdvisorRoleKind } from '@/types/schema';

import { NotesContainer } from './NotesContainer';
import {
  Fields,
  SubformField,
  TRUST_DETAILS_SUBFORM_NAMESPACE,
  TrustDetailsSubformType,
} from './TrustDetailsSubform.types';

interface Props {
  control: Control<Fields>;
  subformValues: TrustDetailsSubformType;
  trusteeOptions: SelectInputProps['options'];
}

export function TrustAdvisorNotes({
  control,
  subformValues,
  trusteeOptions,
}: Props) {
  return (
    <NotesContainer>
      <>
        {subformValues?.trustAdvisors.map((trustAdvisor, i) => {
          const fieldName =
            `${TRUST_DETAILS_SUBFORM_NAMESPACE}.trustAdvisors.${i}.note` as const satisfies SubformField;
          const isOtherLevel = trustAdvisor.level === TrustAdvisorLevel.Other;
          const isOtherRole = trustAdvisor.role?.includes(
            TrustAdvisorRoleKind.Other
          );

          const name = (
            trusteeOptions.find((option) => {
              if ('value' in option) {
                return option.value === trustAdvisor.trustAdvisorId;
              }
              return false;
            }) as { display: string; value: string } | undefined
          )?.display;

          const shouldShowNotes = (isOtherLevel || isOtherRole) && !!name;
          const labelMap = {
            levelAndDuty: `Level & roles for ${name}`,
            level: `Level for ${name}`,
            role: `Roles for ${name}`,
          };

          let label = '';
          if (isOtherLevel && isOtherRole) {
            label = labelMap.levelAndDuty;
          } else if (isOtherLevel) {
            label = labelMap.level;
          } else if (isOtherRole) {
            label = labelMap.role;
          }

          if (shouldShowNotes) {
            return (
              <FormAwareTextInput<Fields>
                key={fieldName}
                control={control}
                fieldName={fieldName}
                label={label}
                multiline
                rows={2}
                resizable
              />
            );
          }

          return null;
        })}
      </>
    </NotesContainer>
  );
}
